import React from 'react';
import { cn } from '../../utils/cn';

const buttonVariants = {
    base: "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-primary-500 focus-visible:ring-primary-200 focus-visible:ring-2",
    variants: {
        variant: {
            default: 'bg-primary-600 text-white shadow-sm hover:bg-primary-700',
            destructive: 'bg-red-600 text-white shadow-sm hover:bg-red-700',
            outline: 'border border-slate-200 bg-white shadow-sm hover:bg-slate-50 hover:text-slate-900',
            secondary: 'bg-slate-100 text-slate-900 shadow-sm hover:bg-slate-200',
            ghost: 'hover:bg-slate-100 hover:text-slate-900',
            link: 'text-primary-600 underline-offset-4 hover:underline',
        },
        size: {
            default: 'h-9 px-4 py-2',
            sm: 'h-8 rounded-md gap-1.5 px-3',
            lg: 'h-10 rounded-md px-6',
            icon: 'h-9 w-9',
        },
    },
};

export function Button({ className, variant = 'default', size = 'default', asChild = false, ...props }) {
    const Comp = asChild ? 'span' : 'button';
    const variantClasses = buttonVariants.variants.variant[variant] || buttonVariants.variants.variant.default;
    const sizeClasses = buttonVariants.variants.size[size] || buttonVariants.variants.size.default;

    return <Comp className={cn(buttonVariants.base, variantClasses, sizeClasses, className)} {...props} />;
}
